/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetEntity,
} from '../models/index';
import {
    AssetEntityFromJSON,
    AssetEntityToJSON,
} from '../models/index';

export interface CreateAssetRequest {
    assetEntity: AssetEntity;
    sessionId?: string;
}

export interface DeleteAssetRequest {
    assetId: string;
    sessionId?: string;
}

export interface GetAssetRequest {
    assetId: string;
    sessionId?: string;
}

export interface GetAssetStatisticsRequest {
    sessionId?: string;
}

export interface GetAssetVulnerabilitiesRequest {
    assetId: string;
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface GetAssetsRequest {
    page?: number;
    pageSize?: number;
    assetType?: string;
    status?: string;
    sessionId?: string;
}

export interface UpdateAssetRequest {
    assetId: string;
    assetEntity: AssetEntity;
    sessionId?: string;
}

/**
 * AssetsApi - interface
 * 
 * @export
 * @interface AssetsApiInterface
 */
export interface AssetsApiInterface {
    /**
     * Create a new asset (manual creation - primary source is integrations)
     * @summary Create asset
     * @param {AssetEntity} assetEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    createAssetRaw(requestParameters: CreateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a new asset (manual creation - primary source is integrations)
     * Create asset
     */
    createAsset(requestParameters: CreateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Soft delete an asset (retains for audit/compliance)
     * @summary Delete asset
     * @param {string} assetId Asset ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    deleteAssetRaw(requestParameters: DeleteAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Soft delete an asset (retains for audit/compliance)
     * Delete asset
     */
    deleteAsset(requestParameters: DeleteAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed information about an asset
     * @summary Get asset by ID
     * @param {string} assetId Asset ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetRaw(requestParameters: GetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about an asset
     * Get asset by ID
     */
    getAsset(requestParameters: GetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get statistics about assets (total, by type, by status)
     * @summary Get asset statistics
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetStatisticsRaw(requestParameters: GetAssetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get statistics about assets (total, by type, by status)
     * Get asset statistics
     */
    getAssetStatistics(requestParameters: GetAssetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all vulnerabilities affecting this asset
     * @summary Get vulnerabilities for asset
     * @param {string} assetId Asset ID
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetVulnerabilitiesRaw(requestParameters: GetAssetVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all vulnerabilities affecting this asset
     * Get vulnerabilities for asset
     */
    getAssetVulnerabilities(requestParameters: GetAssetVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get paginated list of active assets for the tenant
     * @summary List assets
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [assetType] Asset type filter
     * @param {string} [status] Status filter
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsRaw(requestParameters: GetAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get paginated list of active assets for the tenant
     * List assets
     */
    getAssets(requestParameters: GetAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update an existing asset
     * @summary Update asset
     * @param {string} assetId Asset ID
     * @param {AssetEntity} assetEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    updateAssetRaw(requestParameters: UpdateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update an existing asset
     * Update asset
     */
    updateAsset(requestParameters: UpdateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class AssetsApi extends runtime.BaseAPI implements AssetsApiInterface {

    /**
     * Create a new asset (manual creation - primary source is integrations)
     * Create asset
     */
    async createAssetRaw(requestParameters: CreateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['assetEntity'] == null) {
            throw new runtime.RequiredError(
                'assetEntity',
                'Required parameter "assetEntity" was null or undefined when calling createAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/assets`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssetEntityToJSON(requestParameters['assetEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a new asset (manual creation - primary source is integrations)
     * Create asset
     */
    async createAsset(requestParameters: CreateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete an asset (retains for audit/compliance)
     * Delete asset
     */
    async deleteAssetRaw(requestParameters: DeleteAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling deleteAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/assets/{assetId}`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Soft delete an asset (retains for audit/compliance)
     * Delete asset
     */
    async deleteAsset(requestParameters: DeleteAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about an asset
     * Get asset by ID
     */
    async getAssetRaw(requestParameters: GetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling getAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/assets/{assetId}`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about an asset
     * Get asset by ID
     */
    async getAsset(requestParameters: GetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about assets (total, by type, by status)
     * Get asset statistics
     */
    async getAssetStatisticsRaw(requestParameters: GetAssetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/assets/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get statistics about assets (total, by type, by status)
     * Get asset statistics
     */
    async getAssetStatistics(requestParameters: GetAssetStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAssetStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all vulnerabilities affecting this asset
     * Get vulnerabilities for asset
     */
    async getAssetVulnerabilitiesRaw(requestParameters: GetAssetVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling getAssetVulnerabilities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/assets/{assetId}/vulnerabilities`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all vulnerabilities affecting this asset
     * Get vulnerabilities for asset
     */
    async getAssetVulnerabilities(requestParameters: GetAssetVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAssetVulnerabilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paginated list of active assets for the tenant
     * List assets
     */
    async getAssetsRaw(requestParameters: GetAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['assetType'] != null) {
            queryParameters['assetType'] = requestParameters['assetType'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/assets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get paginated list of active assets for the tenant
     * List assets
     */
    async getAssets(requestParameters: GetAssetsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing asset
     * Update asset
     */
    async updateAssetRaw(requestParameters: UpdateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling updateAsset().'
            );
        }

        if (requestParameters['assetEntity'] == null) {
            throw new runtime.RequiredError(
                'assetEntity',
                'Required parameter "assetEntity" was null or undefined when calling updateAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/assets/{assetId}`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssetEntityToJSON(requestParameters['assetEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update an existing asset
     * Update asset
     */
    async updateAsset(requestParameters: UpdateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
